import moment from 'moment';
import { MAX_INTERVAL_SIZE, RELATIVE_TICK_POSITION } from './timeline-constants.js';
import { getIntervalTime } from './timeline-utils.js';
const getInterval = (date, intervals) => {
    const interval = intervals.find((key, index) => ((date.isSameOrAfter(key) && date.isBefore(intervals[index + 1]))
        || index === intervals.length - 1));
    //@ts-ignore always have a interval
    return interval;
};
const getIntervalDifference = (date, intervals) => {
    const interval = getInterval(date, intervals);
    return moment.duration(date.diff(interval)).asMinutes();
};
const getPercentual = (date, interval, intervals) => {
    const intervalValue = getIntervalTime(interval) || getFitInterval(date, intervals);
    const x = getIntervalDifference(date, intervals) * 100;
    return x / intervalValue;
};
const getFitInterval = (date, intervals) => {
    const fitInterval = getInterval(date, intervals);
    const index = intervals.indexOf(fitInterval);
    return Math.abs(moment.duration(fitInterval.diff(intervals[index + 1])).asMinutes());
};
const getRelativePosition = (date, interval, intervals) => {
    const relativePerct = (MAX_INTERVAL_SIZE * getPercentual(date, interval, intervals)) / 100;
    return relativePerct;
};
const getAbsolutePosition = (date, interval, intervals) => {
    const intervalsLenght = intervals.indexOf(getInterval(date, intervals));
    const position = (intervalsLenght * MAX_INTERVAL_SIZE) + getRelativePosition(date, interval, intervals);
    return parseFloat(position.toFixed(2));
};
const getFitAbsolutePosition = (date, intervals) => {
    return intervals.indexOf(getInterval(date, intervals)) * MAX_INTERVAL_SIZE + RELATIVE_TICK_POSITION;
};
export { getAbsolutePosition, getFitAbsolutePosition, };
//# sourceMappingURL=timeline-position-utils.js.map